import _ from "lodash";
import DP_ACTIONS from "../actions/DataProviderActions";
import lodash from "lodash/core";
import {DPSortFields} from "../constants/DataProviderActionConstants";
import SortDirection from "../../../common/constants/SortDirection";
import {listPageGlobalFilter} from "../../../common/utils/FilterFunctions";

const countriesData = require("../../../common/resources/countries.json");

const initialState = {
    all_providers: [],
    all_organizations: [],
    filtered_all_organizations: [],
    dpSortKey: DPSortFields.PROVIDER_NAME,
    dpSortDirection: SortDirection.ASC,
    dpFilterOptionsObj: {
        dpFilterOptions: [],
        countryOptions: [],
    },
    dpFilters: {
        providerNameFilter: null,
        countryFilter: [],
    },
    dp_filtered_state: true,
}

const providersReducer = (state = initialState, action) => {
    switch (action.type) {

        case DP_ACTIONS.Types.DP_GLOBAL_SEARCH: {
            let newState = _.cloneDeep(state);
            newState.filtered_all_organizations = listPageGlobalFilter(action.payload, newState.all_organizations);

            return newState;
        }

        case DP_ACTIONS.Types.TOGGLE_DP_SORT: {
            let newState = _.cloneDeep(state);
            newState.dpSortDirection = newState.dpSortDirection === SortDirection.ASC
                ? SortDirection.DESC : SortDirection.ASC;
            if (newState.dpSortDirection === SortDirection.ASC) {
                newState.filtered_all_organizations = _.sortBy(newState.filtered_all_organizations,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]);
            } else {
                newState.filtered_all_organizations = _.sortBy(newState.filtered_all_organizations,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]).reverse();
            }
            newState.dpSortKey = action.payload;
            return newState;
        }


        case DP_ACTIONS.Types.LOAD_ALL_DATA_PROVIDERS: {
            let newState = _.cloneDeep(state);
            newState.all_providers = action.payload;
            return newState;
        }

        case DP_ACTIONS.Types.LOAD_ALL_DATA_PROVIDERS_FOR_LIST_PAGE: {
            let newState = _.cloneDeep(state);
            newState.all_organizations = action.payload;
            newState.filtered_all_organizations = newState.all_organizations;

            // reformat the type of associated countries from string to array.
            newState.filtered_all_organizations.forEach(org => {
                if (org.associated_countries !== null) {
                    if (org.associated_countries !== "") {
                        org.associated_countries = org.associated_countries.split(",");
                    } else {
                        // for DP with no associated countries, DB returns data as empty string
                        // assign null so it skips the populate filter process.
                        org.associated_countries = null
                    }

                }
            })

            // Wrapper around the inbuilt sort method to perform some additional tasks.
            let sortOptions = (options) => {
                let sortedOption = options;
                const allObject = {value: "all", label: "All"};
                // Sort the options in ascending alphabetical order
                sortedOption.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1)
                sortedOption.unshift(allObject);
                return sortedOption;
            }

            // create the added items arrays
            let providerNamesAdded = [];
            let countriesAdded = [];


            // Only populate the filters on the initial API call. After which they will
            // remain accessible at all times, since they are living in the state object.
            if (newState.dpFilterOptionsObj.dpFilterOptions.length === 0 &&
                newState.dpFilterOptionsObj.countryOptions.length === 0) {

                newState.all_organizations.forEach(org => {

                    // test if the provider name has already been added as a filter option, if not - add it
                    if (!providerNamesAdded.includes(org.provider_name)) {
                        providerNamesAdded.push(org.provider_name);
                        newState.dpFilterOptionsObj.dpFilterOptions.push({
                            value: org.provider_name,
                            label: org.provider_name
                        });
                    }

                    // test if the country has already been added as a filter option, if not - add it
                    if (org.associated_countries !== null) {
                        org.associated_countries.forEach(country => {
                            if (!countriesAdded.includes(country)) {
                                // get the country label
                                const countryOption = lodash.find(countriesData, {
                                    value: country
                                });
                                countriesAdded.push(country);
                                newState.dpFilterOptionsObj.countryOptions.push({
                                    value: countryOption.value,
                                    label: countryOption.label
                                });
                            }
                        })
                    }
                });

                newState.dpFilterOptionsObj.dpFilterOptions = sortOptions(newState.dpFilterOptionsObj.dpFilterOptions);
                newState.dpFilterOptionsObj.countryOptions = sortOptions(newState.dpFilterOptionsObj.countryOptions);
            }

            newState.dp_filtered_state = false;


            return newState;
        }

        case DP_ACTIONS.Types.SET_DP_LIST_FILTER: {
            let newState = _.cloneDeep(state);
            const filterType = action.payload.filterType;
            const filterOption = action.payload.filterOption;
            // add filter type
            if (filterType === "provider") {
                newState.dpFilters.providerNameFilter = filterOption;
            } else if (filterType === "country") {
                newState.dpFilters.countryFilter = filterOption;
            }
            return newState;
        }

        case DP_ACTIONS.Types.FILTER_DATA_PROVIDERS: {
            let newState = _.cloneDeep(state);

            // First filter by DP name
            let dpArr = newState.all_organizations;
            if (newState.dpFilters.providerNameFilter !== null) {
                if (newState.dpFilters.providerNameFilter.value !== "all") {
                    dpArr = lodash.filter(dpArr, {
                        provider_name: newState.dpFilters.providerNameFilter.value
                    });
                }
            }

            // filter by country
            let dpFilteredArr = dpArr;
            if (newState.dpFilters.countryFilter !== null) {
                if (newState.dpFilters.countryFilter.length !== 0) {
                    const isAll = newState.dpFilters.countryFilter.filter(f => f.value === 'all');
                    if (isAll.length === 0) {
                        const filterByCountry = (dp) => {
                            if (dp.associated_countries === null) {
                                return false;
                            } else {
                                const countryCodes = newState.dpFilters.countryFilter.map(x => x.value)
                                if (dp.associated_countries.some(elem => countryCodes.includes(elem))) {
                                    return true;
                                }
                            }
                        }

                        dpFilteredArr = dpFilteredArr.filter(filterByCountry);
                    }
                }
            }

            newState.filtered_all_organizations = dpFilteredArr
            newState.dp_filtered_state = true;

            return newState;
        }

        default:
            return state;

    }
}

export default providersReducer;
